import { useAccess } from "components/permissions/Access"
import { chatQueuesPath } from "./Paths"
import permissions from "constants/permissions"

export const useContactCenterChatQueuesAccess = () => useAccess([permissions.users.generalAccess], chatQueuesPath)
